import mapActions from './mapActions';

export default mapActions('building_issues', {
    fetchAll_url: data => `/api/building_issues/building/${data.building_id}`
});
